// * -------------------------------- NPM --------------------------------------
import * as React from 'react'

// * -------------------------------- MODULE --------------------------------------
import IconComponent from '../Icon/Icon'
import Linkable, { LinkableProps } from '../Link/Linkable'
import Loader from '../Loaders/Loader'
import { BaseButtonProps, renderButtonStyle } from './types'
import { Clickable } from '../../../types/onFunction'
import { IFlexItem, renderFlexItem } from '../Flex/FlexItem'
import { IconProps } from '../../../types/base'

export interface ButtonProps
  extends Clickable<[React.MouseEvent<HTMLButtonElement>]>,
    BaseButtonProps,
    IconProps,
    IFlexItem {}

const Button = (props: ButtonProps) => {
  // * ----------------------------------------------------------------------------------------
  // * -------------------------------- INIT --------------------------------------
  // * ----------------------------------------------------------------------------------------

  const { icon, label, variant, onClick, semantic, size, isLoading, isDisable, dropDown, type, displayAsText } = props
  const btn = 'mv-btn'

  // * ----------------------------------------------------------------------------------------
  // * -------------------------------- RENDERs --------------------------------------
  // * ----------------------------------------------------------------------------------------
  const renderData = () => {
    return (
      <>
        {(icon && (
          <span className={`${btn}__icon`}>
            <IconComponent icon={icon} />
          </span>
        )) ||
          null}
        {label && <span className={`${btn}__text`}>{label}</span>}
        {dropDown && (
          <span className={`${btn}-ddown__icon-select`}>
            <IconComponent icon={'chevron-down'} />
          </span>
        )}
        {(isLoading && <Loader />) || null}
      </>
    )
  }

  return (
    <button
      className={`${btn} btn btn-${renderButtonStyle(semantic, variant, size, displayAsText)} ${
        isLoading ? `${btn}--loading` : ''
      } ${renderFlexItem({ ...(props as IFlexItem) })}`}
      onClick={e => {
        e.currentTarget.blur()
        if (onClick) {
          onClick(e)
        }
      }}
      disabled={isLoading || isDisable}
      type={(type && type) || 'button'}
      onBlur={props.onBlur}
      tabIndex={props.tabIndex}
      onFocus={props.onFocus}
    >
      {renderData()}
    </button>
  )
}

// * ------------------------------------------
// * Helpers Component that pre-fill some props
// * ------------------------------------------
export interface LinkButtonProps extends LinkableProps, BaseButtonProps, IconProps, IFlexItem {}
export const LinkButton = Linkable(Button)

export default Button
